// extracted by mini-css-extract-plugin
module.exports = {"embed":"soundcloud-embed_embed__m4s_i","is-compact":"soundcloud-embed_is-compact__1daLs"};